import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom';

import { Button } from 'components'
import Picoline from 'resources/picoline-white.svg'
import SubmarkLogo from 'resources/Logo/primary-logo-1.png'

const Container = styled.div`
    height: 3rem;
    padding: 2rem 0.5rem 1rem 1.5rem;
    /* margin: 0 1rem; */
    display: grid;
    grid-template-columns: 1fr auto;
    align-content: center;
    align-items: center;
    font-size: 0.9rem;
    background-color: #2B2B2B;
    z-index: 5;
    /* @media (max-width: 1100px) {
        margin: 0 2rem;
    } */
`

const Divider = styled.div`
    margin: 0.1rem;
    border: 1px solid #999999;
    height: 1rem;
    border-radius: 5px;
    align-self: center;
`

const Header = props => {
    let history = useHistory()

    const buttonStyle = {
        backgroundColor: '#2B2B2B',
        boxShadowColor: 'transparent'
    }

    return (
        <Container>
            <img src={SubmarkLogo} style={{width:'auto', height:'1.5rem',objectFit:'contain', cursor: 'pointer'}} onClick={() => history.push('/')}/>
            <div style={{display: 'flex'}}>
                <Button text='Pricing' styles={buttonStyle} onSelect={() => history.push('/pricing')}/>
                <Divider/>
                <Button text='Login' styles={buttonStyle} onSelect={() => history.push('/login')}/>
                <Button text='Register' styles={{backgroundColor: '#957fef'}} onSelect={() => history.push('/register')}/>
            </div>
        </Container>
    )
}

export default Header;